import { Controller } from "@hotwired/stimulus"

// Contrôleur Stimulus pour mettre à jour la couleur en temps réel
export default class extends Controller {
  static targets = ["input", "preview"]

  connect() {
    // Initialiser la couleur du prévisualisateur avec la valeur actuelle
    this.updatePreviewColor()
  }

  // Mettre à jour la couleur du prévisualisateur lorsque l'utilisateur change la couleur
  updateColor() {
    this.updatePreviewColor()
  }

  // Mettre à jour la couleur du prévisualisateur
  updatePreviewColor() {
    const color = this.inputTarget.value
    this.previewTarget.style.backgroundColor = color
  }
}
